module.exports = __webpack_public_path__ + "static/media/sampleReport4.70a2773b.png";